import { ExpandableOfferFilterMenuGroupId, ExpandableVenueFilterMenuGroupId, SelectableOfferFilterId } from './types';
import { SelectableItemsGroup } from '../SelectableAccordion';

export const OFFER_FILTER_OPTION_LABELS: Record<SelectableOfferFilterId, string> = Object.freeze({
  WITH_IMAGES: 'shared-menu.editor.filter-menu.options.with-images',
  WITHOUT_IMAGES: 'shared-menu.editor.filter-menu.options.without-images',
  DISABLED: 'shared-menu.editor.filter-menu.options.disabled',
  CANNOT_BE_ORDERED: 'shared-menu.editor.filter-menu.options.cannot-be-ordered',
  ACTIVE: 'shared-menu.editor.filter-menu.options.active',
  INACTIVE: 'shared-menu.editor.filter-menu.options.inactive',
  WITHOUT_DISCOUNT: 'shared-menu.editor.filter-menu.options.without-discount',
  USE_DISCOUNTED_PRICE: 'shared-menu.editor.filter-menu.options.use-discounted',
  USE_PERCENTAGE: 'shared-menu.editor.filter-menu.options.use-percentage',
  SOLD_OUT: 'shared-menu.editor.filter-menu.options.sold-out',
  CONNECTED: 'shared-menu.editor.filter-menu.options.connected',
  NOT_CONNECTED: 'shared-menu.editor.filter-menu.options.not-connected',
  WITH_GTIN: 'shared-menu.editor.filter-menu.options.with-gtin',
  WITHOUT_GTIN: 'shared-menu.editor.filter-menu.options.without-gtin',
});

export const OFFER_FILTER_GROUP_LABELS: Record<ExpandableOfferFilterMenuGroupId, string> = Object.freeze({
  STATUS: 'shared-menu.editor.filter-menu.groups.status',
  IMAGE_COVERAGE: 'shared-menu.editor.filter-menu.groups.image-coverage',
  DISCOUNT: 'shared-menu.editor.filter-menu.groups.discount',
  CATALOG: 'shared-menu.editor.filter-menu.groups.catalog',
  GTIN: 'shared-menu.editor.filter-menu.groups.gtin',
});

export const OFFER_FILTER_MENU_ITEMS: SelectableItemsGroup<SelectableOfferFilterId>[] = [
  {
    groupLabel: OFFER_FILTER_GROUP_LABELS.STATUS,
    groupId: 'STATUS',
    type: 'checkbox',
    options: [
      {
        label: OFFER_FILTER_OPTION_LABELS.ACTIVE,
        id: 'ACTIVE',
        hide: false,
        disabled: false,
      },
      {
        label: OFFER_FILTER_OPTION_LABELS.INACTIVE,
        id: 'INACTIVE',
        hide: false,
        disabled: false,
      },
      {
        label: OFFER_FILTER_OPTION_LABELS.DISABLED,
        id: 'DISABLED',
        hide: false,
        disabled: false,
      },
      {
        label: OFFER_FILTER_OPTION_LABELS.SOLD_OUT,
        id: 'SOLD_OUT',
        hide: false,
        disabled: false,
      },
      // TODO: Uncomment this when we have `purchasabilityErrors`
      // {
      //   label: OFFER_FILTER_OPTION_LABELS.CANNOT_BE_ORDERED,
      //   id: 'CANNOT_BE_ORDERED',
      //   hide: false,
      //   disabled: false,
      // },
    ],
    hide: false,
  },
  {
    groupLabel: OFFER_FILTER_GROUP_LABELS.IMAGE_COVERAGE,
    groupId: 'IMAGE_COVERAGE',
    type: 'radio',
    options: [
      {
        label: OFFER_FILTER_OPTION_LABELS.WITH_IMAGES,
        id: 'WITH_IMAGES',
        hide: false,
        disabled: false,
      },
      {
        label: OFFER_FILTER_OPTION_LABELS.WITHOUT_IMAGES,
        id: 'WITHOUT_IMAGES',
        hide: false,
        disabled: false,
      },
    ],
    hide: false,
  },
  {
    groupLabel: OFFER_FILTER_GROUP_LABELS.DISCOUNT,
    groupId: 'DISCOUNT',
    type: 'radio',
    options: [
      {
        label: OFFER_FILTER_OPTION_LABELS.WITHOUT_DISCOUNT,
        id: 'WITHOUT_DISCOUNT',
        hide: false,
        disabled: false,
      },
      {
        label: OFFER_FILTER_OPTION_LABELS.USE_DISCOUNTED_PRICE,
        id: 'USE_DISCOUNTED_PRICE',
        hide: false,
        disabled: false,
      },
      {
        label: OFFER_FILTER_OPTION_LABELS.USE_PERCENTAGE,
        id: 'USE_PERCENTAGE',
        hide: false,
        disabled: false,
      },
    ],
    hide: false,
  },
  {
    groupLabel: OFFER_FILTER_GROUP_LABELS.CATALOG,
    groupId: 'CATALOG',
    type: 'radio',
    options: [
      {
        label: 'Connected',
        id: 'CONNECTED',
        hide: false,
        disabled: false,
      },
      {
        label: 'Not connected',
        id: 'NOT_CONNECTED',
        hide: false,
        disabled: false,
      },
    ],
    hide: false,
  },
  {
    groupLabel: OFFER_FILTER_GROUP_LABELS.GTIN,
    groupId: 'GTIN',
    type: 'radio',
    options: [
      {
        label: OFFER_FILTER_OPTION_LABELS.WITH_GTIN,
        id: 'WITH_GTIN',
        hide: false,
        disabled: false,
      },
      {
        label: OFFER_FILTER_OPTION_LABELS.WITHOUT_GTIN,
        id: 'WITHOUT_GTIN',
        hide: false,
        disabled: false,
      },
    ],
    hide: false,
  },
];

export const VENUE_FILTER_GROUP_LABELS: Record<ExpandableVenueFilterMenuGroupId, string> = Object.freeze({
  CITY: 'shared-menu.toolbar.filter-venues.groups.city',
});
